<template>
  <v-snackbar v-model="snackbar" :color="variant" multi-line :timeout="timeout" top>
    <v-card flat :color="variant" dark>
    <v-card-title class="subtitle-1">{{ message }}</v-card-title>
    <v-divider color="white" v-if="showList"></v-divider>
    <v-card-text v-if="showList" class="pa-0 ma-0">
        <v-list class="list-error" dense>
          <v-list-item v-for="item in items" :key="item.index" class="list-tile">
            <v-list-item-avatar>
            <v-icon color="white" size=8>mdi-checkbox-blank-circle</v-icon>
          </v-list-item-avatar>
            <v-list-item-content>{{item.msg}}</v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card-text>
    </v-card>
      <v-btn text @click="disposeNotification">
        <v-icon>mdi-close</v-icon>
      </v-btn>

  </v-snackbar>
</template>

<script>
import { EventBus } from '@/router/bus'

export default {
  data () {
    return {
      snackbar: false,
      message: '',
      variant: 'info',
      timeout: 0,
      showList: false,
      showScroll: false,
      items: []
    }
  },
  created () {
    EventBus.$on('alert', (data) => {
      this.variant = data.variant
      this.message = data.message
      this.snackbar = true
      if (data.errors && data.errors.length > 0) {
        this.items = data.errors
        this.showScroll = this.items.length > 3
        this.showList = true
      }
    })

    EventBus.$on('notification-close', () => {
      this.disposeNotification()
    })
  },
  methods: {
    disposeNotification () {
      this.snackbar = false
      this.showList = false
      this.items = []
    }
  }
}
</script>
<style lang="scss" type="text/scss" scoped>

  @import '~@/assets/scss/variables.scss';

    .alert-top {
        position: absolute;
        top: 64px;
        z-index: 99;
        border-radius: 0;
        margin-left: 5px;
        width: calc(100% - 10px);
    }

  .mainContainer {
    background-color:transparent;
    padding-top: 2px;
    margin-top: 2px;
    width: 120vh;
  }

  .messageArea {
    min-width:93%;
    max-width:93%;
    padding-top:2%;
    background: transparent;
    color: white;
    padding-left:-100px;
    margin-top:-10px;
    margin-bottom: 2%;
  }

  .closeArea {
    min-width:7%;
    max-width:7%;
    padding-top:7px;
    background: transparent;
    color: white;
    margin-top:-16px;
  }

  .closeIcon {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    margin: 0;
  }

  .topContainer {
    background-color: transparent;
    min-width: calc(100%);
  }

  .list-error {
    background-color:  rgb(255, 82, 82) !important;
  }

  .list-error-long {
    background-color: rgb(255, 82, 82) !important;
    height:250px;
    overflow-y: scroll;
  }

  .list-tile {
    background-color: rgb(255, 82, 82) !important;
    margin: 0;
    padding: 2px 0 2px 0;
    border-bottom: none;
  }

  .alert-text {
    font-size: 14px;
    color: rgb(250, 250, 250);
    padding-right: 10px;
    min-width: 93%;
  }

  .alert-pointer {
    margin-left: -10px;
    max-width: 7%;
  }

  .alert-pointer-icon {
      color: white;
  }

</style>
